import type { WRealizationsTestimonialsTranslations } from "./pl";

export const en: WRealizationsTestimonialsTranslations = {
  defaultTitle: "Selected realizations",
  seeRealization: "See realization",
  seeAll: "All realizations",
  prev: "Previous",
  next: "Next",
  goToSlide: "Go to testimonial",
};
